const { getNumber, timestampToDate } = require('../utils');
export default [
    {
        title: '机器人',
        type: 'string',
        dataIndex: 'name',
        key: 'name',
        width: '8%',
        sorter: (a, b) => getNumber(a.name) - getNumber(b.name),
        defaultSortOrder: 'ascend',
        // editable: true,
    },
    {
        title: '类型',
        type: 'string',
        dataIndex: 'type',
        key: 'type',
        width: '12%',
        editable: true,
    },
    {
        title: '关键字',
        type: 'string',
        dataIndex: 'keyword',
        key: 'keyword',
        width: '10%',
        editable: true,
    },
    {
        title: '验证码',
        type: 'string',
        dataIndex: 'message',
        key: 'message',
        width: '8%',
        editable: true,
    },
    {
        title: '手机号',
        type: 'string',
        dataIndex: 'phone',
        key: 'phone',
        width: '11%',
        sorter: (a, b) => getNumber(a.phone) - getNumber(b.phone),
        editable: true,
    },
    {
        title: '状态',
        type: 'string',
        dataIndex: 'status',
        key: 'status',
        width: '9%',
        editable: true,
    },
    {
        title: '到期',
        type: 'string',
        dataIndex: 'expired',
        key: 'expired',
        render: (text) => timestampToDate(text),
        width: '14%',
        editable: true,
    },
    {
        title: '任务id',
        type: 'string',
        dataIndex: 'taskId',
        key: 'taskId',
        width: '12%',
        editable: true,
    },
];